/* eslint-disable @typescript-eslint/no-explicit-any */
import { nanoid } from "nanoid";

import { AIRLINE_NAME_MAP } from "@/constants/airline";
import { PROGRAM_NAME_MAP } from "@/constants/programs";
import { FlightItem } from "@/typings";

/**
 * 转换航班数据
 */
export const transformFlightData = (res: any[]): FlightItem[] => {
  const fieldMapping: Record<string, string> = {
    pm: "payment",
    or: "origin",
    d_t: "departure_time",
    a_t: "arrival_time",
    de: "destination",
    c_t: "cabin_type",
    o_c_t: "final_cabin_type",
    ac: "aircraft",
    a_c: "airline_code",
    a_n: "airline_name",
    f_n: "flight_number",
    l_t: "layover_time",
    r_t: "return_trip",
    t_m: "travel_minutes",
    p_c: "program_code",
    p_n: "program_name",
    a_p: "award_points",
    sc: "surcharge",
    m_a: "mixed_airline",
    p_p: "percent_premium",
    t_m_t: "travel_minutes_total",
    t_t_d: "travel_time_display",
    d_c: "day_count",
    ps: "products",
    c: "currency",
    t: "tax",
    m: "miles",
    ca: "cabin",
  };

  function mapField(item: any, addId = false) {
    Object.keys(item).map((key) => {
      if (key in fieldMapping) {
        item[fieldMapping[key]] = item[key];
        delete item[key];
      }

      if (addId) {
        item.hash = nanoid();
      }
    });
  }

  function mapProduct(item: any) {
    item["airline_name"] = AIRLINE_NAME_MAP[item["airline_code"]];
  }

  return (res || []).map((item: any) => {
    // Mapping each field to a more readable name based on field_mapping
    mapField(item, true);
    mapField(item.fare);
    item.fare.products.map((product: any) => {
      mapField(product, true);
      mapProduct(product);
    });

    item["program_name"] = PROGRAM_NAME_MAP.get(item["program_code"]);
    if ("transfer_options" in item) {
      item["transfer_options"]?.map((option: any) => {
        item["transfer_url"] = PROGRAM_NAME_MAP.get(option["program_code"]);
      });
    }

    return item;
  }) as unknown as FlightItem[];
};
